<template>
    <st-modal
        ref='st-document-template-edit-modal'
        hideable
        hide-footer
        hide-header-delimiter
        hide-footer-delimiter
        no-close-on-backdrop
        no-close-on-esc
        size="md"
        :hideHeaderClose="loading"
        :title="$t('DOCUMENT_TEMPLATE.EDIT_MODAL.TITLE')"
    >
        <template #body>
            <document-template-create-form
                @cancel="hide"
                @submit="submit"
                :item="selectedItem"
            >
                <template #buttons="{ submit, cancel }">
                    <div class="d-flex justify-content-between">
                        <st-button
                            size="large"
                            variant="link"
                            :callback="cancel"
                            :disabled="loading"
                        >
                            {{ $t('GENERAL.BUTTON.CANCEL') }}
                        </st-button>
                        <st-button
                            size="large"
                            :callback="submit"
                            :spinner="loading"
                        >
                            {{ $t('GENERAL.BUTTON.SAVE') }}
                        </st-button>
                    </div>
                </template>
            </document-template-create-form>
        </template>
    </st-modal>
</template>

<script>
export default {
    name: 'DocumentTemplateEditModal',
    components: {
        DocumentTemplateCreateForm: () => import('@/modules/document-template/components/DocumentTemplateCreateForm.vue'),
    },
    props: {
        selectedItem: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
        },
    },
    methods: {
        show() {
            this.$refs['st-document-template-edit-modal'].show();
        },
        hide() {
            this.$refs['st-document-template-edit-modal'].hide();
        },
        submit(item) {
            this.$emit('submit', item);
        },
    },
}
</script>